module.exports = __webpack_public_path__ + "img/search-img.svg";